import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0 bg-[#0a1445] backdrop-blur-sm rounded-lg mb-2" data-id="element-45">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full py-4 sm:py-6 px-4 sm:px-6 text-left" data-id="element-46">
        <h3 className="text-base sm:text-lg md:text-xl font-medium text-white pr-2" data-id="element-47">
          {question}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 ml-2 sm:ml-4" data-id="element-48">
          <ChevronDownIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white/70" data-id="element-49" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-50">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-51">
            <div className="pb-4 sm:pb-6 px-4 sm:px-6 text-white/80 whitespace-pre-line text-sm sm:text-lg" data-id="element-52">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};